'use strict';

module.exports = {
  yearMonthDayFormat: 'YYYY-MM-DD',
  yearMonthDayHoursMinutesFormat: 'YYYY-MM-DD HHmm',
  yearMonthDayHoursMinutesFormatWithColon: 'YYYY-MM-DD HH:mm',
  yearMonthDayHoursMinutesSecondsFormat: 'YYYY-MM-DD HH:mm:ss',
  hoursMinutesDayMonthYearFormat: 'HH mm DD MM YYYY',
  hoursMinutesDayMonthYearSeparatedFormat: 'HH:mm, DD-MM-YYYY',
  utcFormat: 'YYYY-MM-DDThh:mm:ssZ',
  monthDayYearSlashesFormat: 'MM/D/YYYY',
  monthDayYearFullSlashesFormat: 'DD/MM/YYYY',
  dayMonthYearFormat: 'DD-MM-YYYY',
};
